<template>
       <Card v-bind="options"> 
            <div class="card__container">
                <div class="profil__picture__section">
                    <div class="avatar">
                        <span>
                            <img v-if="profilePicture" :src='profilePicture' alt="" srcset="">
                            <img v-else src="https://www.nicepng.com/png/detail/136-1366211_group-of-10-guys-login-user-icon-png.png" alt="" srcset="">
                        </span>
                    </div> 
                    <file-uploader  v-model="uploadedPicture" @input="uploadPicture">
                    <div slot="activator">
                    <Button v-bind="data.picture.button"/>
                    </div>
                    </file-uploader >
                </div>
                <div class="profile__info__section">
                    <div class="profile__header"><span>{{data.profile.title}}</span></div>
                    <form class="profile__form">
                        <div class="section__1">
                            <span class="section_title">{{data.profile.section_1.title}}</span>
                            <div class="form__group">
                                <div class="field__container" v-for="(item,index) in data.profile.section_1.elements" :key="index" :style="`width:${item.width}`">
                                    <!-- <span v-show="['Select','RadioBtn'].includes(item.component)">{{item.label ? item.label : ''}}</span> -->
                                    <components  :is="item.component" :value="user[item.name]" :selected="item.options ? item.options.find(count=>count.name==user[item.name]) : true" :checked="user[item.text]" :disabled="item.disabled"  @input="getValue(item.name,item,...arguments)"  v-bind="Object.assign(item,{width:null})" />
                                    <span class="largeW" v-if="item.name=='email'"> 
                                         <router-link class="edit_emaill" to="/user-email"><i class="fa fa-edit"></i>  Edit email</router-link>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="section__2">
                            <span class="section_title">{{data.profile.section_2.title_1}}</span>
                            <div class="form__group">
                                <div class="field__container" v-for="(item,index) in data.profile.section_2.elements" :key="index" :style="`width:${item.width}`">
                                    <components :is="item.component" :value="user[item.name]"  @input="getValue(item.name,item,...arguments)" v-bind="Object.assign(item,{width:item.component =='Input' ? null : item.width})" />
                                </div>
                            </div>
                            <span class="section_title">{{data.profile.section_2.title_2}}</span>
                            <div class="skills__tags form__group"> 
                                <div class="skill_tag" v-for="(tag, tagInedx) in data.profile.section_2.software_skills" :key="tagInedx">
                                    <input type="checkbox" hidden :checked="user['SoftwareSkills'].includes(tag)"  name="tags" :id="tag">
                                    <label  :for="tag" v-on:click="addTag(tag)" >{{tag}}</label>
                                </div>
                            </div>
                            <div class="submit-btn">
                                <Button v-bind="data.profile.section_2.update_btn"  @click="updateUser"/>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
    </Card>
</template>

<script>
    import Card from '../../../components/global/Card.vue';
    import Input from '../../../components/global/Input.vue';
    import Button from '../../../components/global/Button.vue';
    import Select from '../../../components/global/Select.vue';
    import RadioBtn from '../../../components/global/RadioButton.vue';
    import { db,profileStorageRef } from "../../../firebaseDB";
    import FileUploader from '../../../components/assets/uploader/fileUploader'
    import moment from "moment";

    export default {
        components : { Card, Input, Button, Select, RadioBtn , FileUploader },
        data(){
            return {
                user : {
                    firstName:'',
                    SoftwareSkills:[],
                },
                profilePicture:'',
                uploadedPicture:{
                    fileName: '',
                    file: '',
                    fileURL: ''
                },
                owner_card_options : { 
                    header : {
                        backgroundColor : "#fff",
                        padding : { x : 1.5, y : 0 },
                        border : null,
                    },
                    hasHeader : true,
                },
                options :{
                    padding : { x : 0, y : 0},
                    rounded : .3,
                    boxShadow : {x : 5, y : 5, blur : 1, color : '#e5e5e526'},
                    hasfooter : false,
                    hasHeader : false,
                    boxShadow : { x : 1, y : 3, blur : 5, color : "#ccc"},         
                    bordered : false,
                    margin: "0",
                    main : { 
                        padding : { x : 0, y : 0},
                    },
                },
                data : {
                    picture : {
                        src : "",
                        button :{
                                    name : "UPDATE NEW PICTURE",
                                    type : "submit",
                                    backgroundColor : "#7367f0",
                                    width : "100%",
                                    component : "Button",
                                    padding : { x:2.5, y: 1 ,}
                                },
                        inof_text : ""
                    },
                    profile : {
                        title : "Edit Your personal profile",
                        section_1 : {
                            title : "Profile Informations",
                            elements : [
                                   {
                                        label : "First name",
                                        type : "text",
                                        hint : "Firstname",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:'firstName',
                                        disabled:false
                                    },
                                    {
                                        label : "Last name",
                                        type : "text",
                                        hint : "Lastname",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:'lastName',
                                        disabled:false
                                    },
                                    {
                                            label : "Your tagline",
                                            type : "text",
                                            hint : "Describe yourself in 140 characters or less",
                                            padding : { x : .7, y : .5},
                                            width : "100%",
                                            component : "Input",
                                            name:'tagLine',
                                        disabled:false
                                    },
                                    {
                                            label : "email",
                                            type : "email",
                                            hint : "test@email.com",
                                            padding : { x : .7, y : .5},
                                            width : "100%",
                                            component : "Input",
                                            name:'email',
                                        disabled:true
                                    },
                                    {       
                                            label : "Country",
                                            options : [{id:0,name:"Afghanistan"},{id:1,name:"Albania"},{id:2,name:"Algeria"}],
                                            placeholder : "Choose Country",
                                            padding : { x : .7, y : .65},
                                            width : "50%",
                                            margin : 0,
                                            component : "Select",
                                            name:'country',
                                        disabled:false
                                    },
                                    {
                                            label : "City",
                                            type : "text",
                                            hint : "Which city do you live in ?",
                                            padding : { x : .7, y : .5},
                                            width : "50%",
                                            component : "Input",
                                            name:'city',
                                        disabled:false
                                    },
                                    {
                                            label : "State",
                                            type : "text",
                                            hint : "Which state do you live in ?",
                                            padding : { x : .7, y : .5},
                                            width : "50%",
                                            component : "Input",
                                            name:'state',
                                        disabled:false
                                    },
                                    {
                                            label : "Zip code",
                                            type : "text",
                                            hint : "What are the Zip code of the place you live in ?",
                                            padding : { x : .7, y : .5},
                                            width : "50%",
                                            component : "Input",
                                            name:'zipCode',
                                        disabled:false
                                    },
                                    {
                                            label : "Street Address",
                                            type : "text",
                                            hint : "Which Street do you live in ?",
                                            padding : { x : .7, y : .5},
                                            width : "100%",
                                            component : "Input",
                                            name:'streetAddress',
                                        disabled:false
                                    },
                                    {
                                            label : "Birhday",
                                            type : "date",
                                            hint : "yy/mm/dd",
                                            padding : { x : .7, y : .5},
                                            width : "100%",
                                            component : "Input",
                                            name:'birthday',
                                        disabled:false
                                    },
                                    /*{
                                        label : "Account type",
                                        placeholder : "individual",
                                        options : [],
                                        padding : { x : .7, y : .65},
                                        width : "50%",
                                        margin : 0,
                                        component : "Select",
                                            name:''
                                    },
                                    {
                                        options : [],
                                        placeholder : "Choose",
                                        padding : { x : .7, y : .65},
                                        width : "50%",
                                        margin : 0,
                                        component : "Select",
                                        name:''
                                    },*/
                                    {
                                        label : "You are interested in",
                                        text : "Buying",
                                        id : "Buying",
                                        width : "33.33%",
                                        component : "RadioBtn",
                                        checked : false,
                                        name:'interested'
                                    },
                                    {
                                        text:"Selling",
                                        id : "selling",
                                        width : "33.33%",
                                        component : "RadioBtn",
                                        checked : false,
                                        name:'interested'
                                    },
                                    {
                                        text:"Both",
                                        id : "both",
                                        width : "33.33%",
                                        component : "RadioBtn",
                                        checked : false,
                                        name:'interested'
                                    },
                                    {
                                        label : "Professional information",
                                        type : "text",
                                        multiline : 4,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:'ProfessionalInformation'
                                    },
                            ]
                        },
                         section_2 : {
                            title_1 : "Social Links",
                            title_2 : "Software & skills",
                            software_skills : ['Voxel','MagicalVoxel','Cubik','Cinema 4D','Blender','Modo','3ds max','Photoshop'],
                            update_btn : {
                                        name : "UPDATE INFORMATION",
                                        type : "button",
                                        backgroundColor : "#7367f0",
                                        width : "100%",
                                        padding : { x:2, y: .9 },
                                        component : "Button"
                                    },
                            elements : [
                                   {
                                        label : "Profile website",
                                        type : "text",
                                        hint : "https://exemple.com",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:'ProfileWebsite'
                                    },
                                    {
                                        label : "Facebook username",
                                        type : "text",
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:'FacebookUsername'
                                    },
                                    {
                                        label : "Instagram username",
                                        type : "text",
                                        hint : "@",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:'InstagramUsername'
                                    },
                                    {
                                        label : "twitter username",
                                        type : "text",
                                        hint : "@",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:"twitterUsername"
                                    },
                                    {
                                        label : "Linkedin username",
                                        type : "text",
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input",
                                        name:"LinkedinUsername"
                                    },
                                
                                
                            ]
                        }
                    }
                }
            }
        },
         mounted() {
    let tRef = db.ref().child("users/" + this.$store.state.user.id);
    tRef.once("value").then((snapshot) => {
      let user = snapshot.val();
      if (user) {
        this.profilePicture= user.profileImage
        this.user["firstName"] = user.firstName;
        this.user["lastName"] = user.lastName;
        this.user["email"] = user.email;
        this.user["tagLine"] = user.tagLine;
        this.user["country"] = user.country;
        this.user["city"] = user.city;
        this.user["state"] = user.state;
        this.user["zipCode"] = user.zipCode;
        this.user["streetAddress"] = user.streetAddress;
        this.user["birthday"] = user.birthday;
        this.user["ProfileWebsite"] = user.ProfileWebsite;
        this.user["FacebookUsername"] = user.FacebookUsername;
        this.user["InstagramUsername"] = user.InstagramUsername;
        this.user["twitterUsername"] = user.twitterUsername;
        this.user["LinkedinUsername"] = user.LinkedinUsername;
        this.user["ProfessionalInformation"] = user.ProfessionalInformation;
        this.user["interested"] = user.interested;
        if(user.SoftwareSkills){
        this.user["SoftwareSkills"] = user.SoftwareSkills;
        }
        this.user[user.interested] = true;

      }
    });
  },
  methods : {
    updateUser() {
      let updates = {};
      updates['firstName'] = this.user["firstName"] ?this.user["firstName"]:'';
      updates['lastName'] = this.user["lastName"] ? this.user["lastName"] :'';
      updates['tagLine'] = this.user["tagLine"] ? this.user["tagLine"]:'';
      updates['country'] = this.user["country"] ? this.user["country"]:'';
      updates['city'] = this.user["city"] ? this.user["city"]:'';
      updates['state'] = this.user["state"] ? this.user["state"]:'';
      updates['zipCode'] = this.user["zipCode"] ? this.user["zipCode"]:'';
      updates['streetAddress'] = this.user["streetAddress"] ? this.user["streetAddress"] :'';
      updates['birthday'] = this.user["birthday"] ? this.user["birthday"]:'';
      updates['ProfileWebsite'] = this.user["ProfileWebsite"] ? this.user["ProfileWebsite"]:'';
      updates['FacebookUsername'] = this.user["FacebookUsername"] ? this.user["FacebookUsername"]:'';
      updates['InstagramUsername'] = this.user["InstagramUsername"] ? this.user["InstagramUsername"]:'';
      updates['twitterUsername'] = this.user["twitterUsername"] ? this.user["twitterUsername"]:'';
      updates['LinkedinUsername'] = this.user["LinkedinUsername"] ? this.user["LinkedinUsername"]:'';
      updates['ProfessionalInformation'] = this.user["ProfessionalInformation"] ? this.user["ProfessionalInformation"] :'';
      updates["interested"] = this.user["interested"] ?  this.user["interested"] :'';
      updates["SoftwareSkills"] = this.user["SoftwareSkills"] ? this.user["SoftwareSkills"]:'' ;
      updates["updatedAt"] =  moment().format("YYYY-MM-DD");
      db.ref('users'+`/`+this.$store.state.user.id).update(updates)
        if(this.uploadedPicture.fileName!=''){
          profileStorageRef
              .child(`${this.uploadedPicture.file.lastModified}`)
              .put(this.uploadedPicture.file)
              .then((snapshot) => snapshot.ref.getDownloadURL())
              .catch(function (error) {
                console.log(`Error - ${error.message}`)
              })
              .then((url) => {
                  let update = {};
                update["profileImage"] = url;
                updates["updatedAt"] =  moment().format("YYYY-MM-DD");
                db.ref('users'+`/`+this.$store.state.user.id).update(update)
                this.$router.go(this.$router.currentRoute)
              })
      }

    },
    getValue(name,item,value){
        if(item.component=='RadioBtn'){
         this.user[name] = item.text
        }else{
          this.user[name] = value
        }
      },
      addTag(tag){
         if(this.user['SoftwareSkills'].includes(tag)){
           this.user['SoftwareSkills'].splice(this.user['SoftwareSkills'].indexOf(tag),1)
          }else{
            this.user['SoftwareSkills'].push(tag)
          }
        
      },
      uploadPicture(){
      this.user['profileImage']=this.uploadedPicture
      this.profilePicture= URL.createObjectURL(this.uploadedPicture.file)
      }
  }
    }
</script>

<style lang="scss" scoped>
.submit-btn {
    display: flex;
    justify-content: flex-end;
    button {
        width: fit-content !important;
    }
}
    // .profil__picture__section
    .card__container {
        display : flex;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        width : 100%;

    }
    .profile__header {
        font-size: 1.3rem;
        font-weight: 500;
        text-transform: capitalize;
        padding : 3rem 0;
        display : flex;
        span {
            flex:1;
            position : relative; 
            &:after {
                content: "";
                border : 1px solid #f8f8f8;
                background-color: #f8f8f8;
                position : absolute;
                left:0;
                right:0;
                bottom:-.3rem;
            }
        }
    }

    .profile__info__section {
        flex :1;
        padding: 0 2rem;
        form {
            display : flex;
            flex-wrap: wrap;
        }
    }
    .section__1, .section__2 {
        flex :1;
        padding: 0 1rem;
        .section_title {
            font-size: 1.3rem;
            font-weight: 500;
        }
    }
    .form__group {
        padding : 1.5rem;
        display: flex;
        align-items : flex-end;
        flex-wrap: wrap;
    }
 
    .field__container {
        padding : .2rem ;
        select {
            margin: .5rem 0 !important;
        }
        button {
            font-weight: 500;
            font-size: 1.2rem !important;
        }
   
    }
    .profil__picture__section {
        padding: 2rem 3rem;
        // border : 1px solid red;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        // width : 100%
    }
    .avatar {
        border-radius: 50%;
        height : 12.4rem;
        width : 12.5rem;
        margin : .7rem 0;
        position: relative;
        z-index: 5;
        &:before {
            content : "";
            border : 1px solid #ffffff;
            background-color: #fff;
            border-radius: 50%;
            height : 15.5rem;
            width : 15.5rem;
            position: absolute;
            top:-12%;
            left: -13%;
            z-index: 1;
        }
        &:after {
            @extend .avatar:before;
            // border-color: #ece9e9;
            // border-width: 5px;
            // height: 14rem;
            // width:14rem;
            // top:-6%;
            // left: -7%;
            // z-index: 2;
            border-color: #10db3d;
            border-width: 4px;
            height: 13rem;
            width: 13rem;
            top: -2%;
            left: -2%;
            z-index: 2;
          
        }
        span {
            border-radius: 50%;
            position: absolute;
            z-index: 50;
            top : 0;
            bottom : 0;
            left : 0;
            right : 0;
            img {
                width : 100%;
                height : 100%;
                object-fit: cover;
                border-radius: 50%;
            }
        }
    }
    .skills__tags button{
        margin-top: 2rem !important; 
    }
    .skill_tag {
        input:checked ~ label {
            background-color : #000;
            color : #fff;
        }
        label {
            padding : .5rem 1rem;
            margin-right : .5rem;
            font-size: .9rem;
            border-radius: .2rem;
            background-color : #B9C4E1;
            color : #000;
            font-weight: 400;
            text-align: center;
            cursor: pointer;
            transition: .2s;
            &:hover{
                background-color : #000;
                color : #fff;
            }
        }
    }
    .edit_emaill {
            padding : .5rem 1rem;
            margin-right : .5rem;
            font-size: .9rem;
            border-radius: .2rem;
            background-color : #B9C4E1;
            color : #000;
            font-weight: 400;
            text-align: center;
            cursor: pointer;
            transition: .2s;
            &:hover{
                background-color : #000;
                color : #fff;
            }
            
        }
        .largeW{width:100%}
</style>


// WEBPACK FOOTER //
// src/views/user_profile/info/ownerInfo.vue